export const ENDPOINT = `https://${process.env.NEXT_PUBLIC_MARKETPLACE_GATEWAY_DOMAIN_NAME}`;
